import styled from '@emotion/styled';

import { layers, Theme } from 'theme';

export const MainContainer = styled.div<{
  theme?: Theme;
  error?: boolean;
  isMenuOpen?: boolean;
  isDisabled?: boolean;
}>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  min-height: 48px;
  border: ${({ theme, error }) =>
    `1px solid ${error ? theme.colors.fuzzyWuzzyBrown : theme.colors.alphaGray}`};
  border-radius: 20px;
  padding: 5px 16px 5px 20px;
  background-color: ${({ isDisabled, theme }) =>
    isDisabled ? theme.colors.mineShaftLightest : 'transparent'};
  box-shadow: none;
  outline: none;
  pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'all')};
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
  font-family: ${({ theme }) => theme.fonts.lato};

  ${({ isMenuOpen, theme }) =>
    isMenuOpen
      ? `
border-bottom: 1px solid transparent;
background-color: ${theme.colors.mineShaft};
border-radius: 20px 20px 0px 0px;
`
      : ''}
`;
export const ListContainer = styled.div<{ theme?: Theme }>`
  position: absolute;
  top: 100%;
  left: -1px;
  right: -1px;
  max-height: 500px;
  overflow: scroll;
  border-radius: 0px 0px 20px 20px;
  background-color: ${({ theme }) => theme.colors.mineShaft};
  border: 1px solid ${({ theme }) => theme.colors.alphaGray};
  border-top: none;
  box-shadow: none;
  cursor: pointer;
  z-index: ${layers.modal};
  font-family: ${({ theme }) => theme.fonts.lato};
`;
export const Input = styled.input<{ theme?: Theme }>`
  outline: none;
  color: ${({ theme }) => theme.colors.alphaGray};
  background-color: transparent;
  border: none;
  width: 80%;
  height: 40px;
  input: not(: focus): {
  width: 0;
  height: 0;
} font-family: ${({ theme }) => theme.fonts.lato};
`;
export const SelectedCounter = styled.span<{ theme?: Theme }>`
  background: ${({ theme }) => theme.mainColor};
  color: ${({ theme }) => theme.fontColor};
  width: 25px;
  height: 25px;
  border-radius: 50%;
  font-size: 10px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
`;
